var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.25C0 1.00736 1.00736 0 2.25 0H4.75C5.99264 0 7 1.00736 7 2.25V4.75C7 5.99264 5.99264 7 4.75 7H2.25C1.00736 7 0 5.99264 0 4.75V2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.25C0 10.0074 1.00736 9 2.25 9H4.75C5.99264 9 7 10.0074 7 11.25V13.75C7 14.9926 5.99264 16 4.75 16H2.25C1.00736 16 0 14.9926 0 13.75V11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C9 1.00736 10.0074 0 11.25 0H13.75C14.9926 0 16 1.00736 16 2.25V4.75C16 5.99264 14.9926 7 13.75 7H11.25C10.0074 7 9 5.99264 9 4.75V2.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 9.75C13.25 9.33579 12.9142 9 12.5 9C12.0858 9 11.75 9.33579 11.75 9.75V11.75H9.75C9.33579 11.75 9 12.0858 9 12.5C9 12.9142 9.33579 13.25 9.75 13.25H11.75V15.25C11.75 15.6642 12.0858 16 12.5 16C12.9142 16 13.25 15.6642 13.25 15.25V13.25H15.25C15.6642 13.25 16 12.9142 16 12.5C16 12.0858 15.6642 11.75 15.25 11.75H13.25V9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMenu);
export default __webpack_public_path__ + "static/media/feature-menu.8e8941b1a88e0de5f26932f9a23f0757.svg";
export { ForwardRef as ReactComponent };